import { render } from "./tournament_leaderboard_component.vue?vue&type=template&id=1e3c1d13"
import script from "./tournament_leaderboard_component.vue?vue&type=script&lang=js"
export * from "./tournament_leaderboard_component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__